import { FC } from 'react';

import t from 'utils/translate';
import { fitTextToSize } from 'utils/fit-text-to-size';
import useToggle from 'common/hooks/use-toggle';
import Text from 'admin/components/common/Text';
import { Modal } from 'admin/components/common/Modal';
import Button from 'admin/components/common/Button';
import { ModalManagerProvidedProps } from 'admin/components/common/ModalManager';
import { MODAL } from 'admin/constants/common';
import { Flex } from 'antd';

export type EditorsConflictModalData = {
	email: string;
	name: string;
	onOk: () => void;
	onCancel: () => void;
};

const EditorsConflictModal: FC<ModalManagerProvidedProps<MODAL.STORY_EDITORS_CONFLICT>> = ({ close, data, open }) => {
	const isBusy = useToggle(false);

	const onOkClick = async () => {
		isBusy.set(true);
		await data.onOk();
		isBusy.set(false);
		close();
	};

	const onCancelClick = () => {
		data.onCancel();
		close();
	};

	return (
		<Modal width={564} open={open} destroyOnHidden onCancel={data.onCancel}>
			<Flex vertical gap="large">
				<Flex vertical gap="medium">
					<Text size="subtitle" weight="semibold" compact text={t('editorsConflictModal.title')} />
					<Text size="paragraph" text={t('editorsConflictModal.text', { name: data.email })} />
				</Flex>

				{/* Spacer  */}
				<div />

				<Flex gap="medium">
					<Button view="danger" onClick={onOkClick} loading={isBusy.value}>
						{t('editorsConflictModal.confirm', { name: fitTextToSize(data.name, 16) })}
					</Button>

					<Button view="secondary" onClick={onCancelClick}>
						{t('editorsConflictModal.skip')}
					</Button>
				</Flex>
			</Flex>
		</Modal>
	);
};

export default EditorsConflictModal;
